import { api } from './api';

export const defaultWalkthroughModelsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDefaultWalkthroughModelsAdmin: builder.query({
      query: (params = {}) => {
        const queryParams = {};
        if (params.status != null && params.status !== '') {
          queryParams.status = Number(params.status);
        }
        return {
          url: '/admin/default-walkthrough-models',
          params: queryParams,
        };
      },
      providesTags: ['DefaultWalkthroughModel'],
    }),
    presignDefaultWalkthroughMesh: builder.mutation({
      query: (body) => ({
        url: '/admin/default-walkthrough-models/mesh/presign',
        method: 'POST',
        body,
      }),
    }),
    uploadDefaultWalkthroughPreview: builder.mutation({
      query: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: '/admin/default-walkthrough-models/preview/upload',
          method: 'POST',
          body: formData,
        };
      },
    }),
    createDefaultWalkthroughModel: builder.mutation({
      query: (body) => ({
        url: '/admin/default-walkthrough-models',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['DefaultWalkthroughModel'],
    }),
    updateDefaultWalkthroughModel: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/default-walkthrough-models/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['DefaultWalkthroughModel'],
    }),
  }),
});

export const {
  useGetDefaultWalkthroughModelsAdminQuery,
  usePresignDefaultWalkthroughMeshMutation,
  useUploadDefaultWalkthroughPreviewMutation,
  useCreateDefaultWalkthroughModelMutation,
  useUpdateDefaultWalkthroughModelMutation,
} = defaultWalkthroughModelsApi;
